import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";


@Injectable({providedIn: 'root'})
export class JySystemConfigService extends BaseService {

  private url = 'api/system-config';  // URL to web api

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }



  getSystemInfo(): Observable<any> {
    const url = `${this.getUrl()}/basic?_allow_anonymous=true`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getSystenInfo`)),
      catchError(this.handleError<any>(`getSystenInfo`))
    );
  }

  /**
   * 获取最小密码长度
   */
  getPasswordLength(): Observable<any> {
    const url = `${this.getUrl()}/passwordLength?_allow_anonymous=true`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getPasswordLength`)),
      catchError(this.handleError<any>(`getPasswordLength`))
    );
  }

}

